import server from '../../public/server/server'
const loginApi = {
    login:server.requestPath +  '/login', // 登录
    logOut:server.requestPath +  '/loginOut',//登录页 相关问题
    newPwd:server.requestPath +  '/newPwd',//修改密码
    forgetPwd:server.requestPath +  '/forgetPwd',//忘记密码
    getCode:server.requestPath +'/smsSend',//根据站长电话号码获取验证码
    validateSmsVerifyCode:server.requestPath +'/smsVerifyCode',//验证验证码
    updatePassword:server.requestPath +'/forgetPwd',//修改密码
    phoneVerify:server.requestPath +'/phoneVerify',//修改密码

    manualAuth:server.requestPath+'/manualAuth',//手动实名认证

    queryGroupInfo:server.visualIntercom +'/alarm/queryGroupInfo',//获取当前登陆用户的未读消息
    setGroupInfoFinish:server.visualIntercom +'/alarm/setGroupInfoFinish',//设置当前登陆用户的消息已读
    
}

export {
    loginApi
}
